import moment from "moment";
import { withSnackbar } from "notistack";
import propTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { compose } from "recompose";

import { GeoJSON, Pane, Popup } from "react-leaflet";

import { couleurZaDeploiement, removeInformationsDeploiementDsp } from "../../../enums";
import { Sro } from "../../../services";

const ZaSro = ({
  dsp,
  marcheList,
  optionSelectedConfigCarte,
  zoom,
  MIN_ZOOM_DISPLAY_SRO,
  MAX_ZOOM_DISPLAY_SRO,
  setIsLoading,
  enqueueSnackbar,
}) => {
  const [listeSroZa, setListeSroZa] = useState([]);
  const [abortSroZa, setAbortSroZa] = useState(new AbortController());

  const displaySroZa = async () => {
    abortSroZa.abort();
    const abort = new AbortController();
    setAbortSroZa(abort);

    Sro.getSroZaByCodesReseau(
      marcheList.map(e => e.codeReseau),
      abort,
    )
      .then(responseListeSro => {
        const listeSroZaTemp = responseListeSro.features
          .filter(itemZa => itemZa.properties.statut !== "ABANDONNE")
          .map(itemZa => {
            const itemZaTemp = { ...itemZa };
            let color;

            if (itemZa.properties.codeReseau === "AI-VENU") {
              // Classement des SRO ZA par année
              if (itemZaTemp.properties.ANNEE_DEP <= 2020) {
                color = couleurZaDeploiement.ZASROCommercialisable20182020;

                itemZaTemp.properties = {
                  state: "SRO_DEP_201820",
                  anneeDep: "2018 - 2020",
                  ...itemZaTemp.properties,
                };
              } else if (itemZaTemp.properties.ANNEE_DEP === 2021) {
                color = couleurZaDeploiement.ZASROCommercialisable2021;

                itemZaTemp.properties = {
                  state: "SRO_DEP_2021",
                  anneeDep: "2021",
                  ...itemZaTemp.properties,
                };
              } else if (itemZaTemp.properties.ANNEE_DEP === 2022) {
                color = couleurZaDeploiement.ZASROCommercialisable2022;

                itemZaTemp.properties = {
                  state: "SRO_DEP_2022",
                  anneeDep: "2022",
                  ...itemZaTemp.properties,
                };
              } else if (itemZaTemp.properties.ANNEE_DEP >= 2023) {
                color = couleurZaDeploiement.ZASROCommercialisable2023;

                itemZaTemp.properties = {
                  state: "SRO_DEP_2023",
                  anneeDep: "2023",
                  ...itemZaTemp.properties,
                };
              }
            } else if (itemZaTemp.properties.Ouverture_COM === "OC") {
              color = couleurZaDeploiement.ZaSroOpen;

              itemZaTemp.properties = {
                state: "SRO_OPEN",
                anneeDep: itemZaTemp.properties.ANNEE_COM,
                ...itemZaTemp.properties,
              };
            } else if (itemZaTemp.properties.Ouverture_COM === "OP") {
              color = couleurZaDeploiement.ZaSroSoon;

              itemZaTemp.properties = {
                state: "SRO_SOON",
                anneeDep: itemZaTemp.properties.ANNEE_COM,
                ...itemZaTemp.properties,
              };
              /**
               * Il arrive que la livraison d'une ZA ait pris du retard et qu'elle ne soit pas encore commercialisée.
               * Ces ZAs seront affichées comme étant livrées sur l'année en cours.
               */
            } else if (itemZaTemp.properties.ANNEE_COM <= moment().year()) {
              color =
                dsp.codeReseau === "AI-MNUM"
                  ? couleurZaDeploiement.ZaSroYearNX
                  : couleurZaDeploiement.ZaSroYearN0;

              itemZaTemp.properties = {
                state: "SRO_YEAR_N0",
                anneeDep: itemZaTemp.properties.ANNEE_COM,
                ...itemZaTemp.properties,
              };
            } else if (itemZaTemp.properties.ANNEE_COM === moment().year() + 1) {
              color =
                dsp.codeReseau === "AI-MNUM"
                  ? couleurZaDeploiement.ZaSroYearNX
                  : couleurZaDeploiement.ZaSroYearN1;

              itemZaTemp.properties = {
                state: "SRO_YEAR_N1",
                anneeDep: itemZaTemp.properties.ANNEE_COM,
                ...itemZaTemp.properties,
              };
            } else if (itemZaTemp.properties.ANNEE_COM === moment().year() + 2) {
              color =
                dsp.codeReseau === "AI-MNUM"
                  ? couleurZaDeploiement.ZaSroYearNX
                  : couleurZaDeploiement.ZaSroYearN2;

              itemZaTemp.properties = {
                state: "SRO_YEAR_N2",
                anneeDep: itemZaTemp.properties.ANNEE_COM,
                ...itemZaTemp.properties,
              };
            }

            const styleSro = {
              color: color,
              weight: 2,
              opacity: 1,
              fillColor: color,
              dashArray: "0",
              fillOpacity: 0.5,
            };

            return {
              item: itemZaTemp,
              style: styleSro,
            };
          });

        setListeSroZa(listeSroZaTemp);
      })
      .catch(e => {
        if (e.code !== "ERR_CANCELED") {
          enqueueSnackbar(process.env.ERREUR_SERVEUR, {
            variant: "error",
            autoHideDuration: 6000,
          });
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    displaySroZa();

    return () => abortSroZa.abort();
  }, []);

  return (
    <Pane name="sro" className="leaflet-sro-pane">
      {zoom >= MAX_ZOOM_DISPLAY_SRO &&
        zoom <= MIN_ZOOM_DISPLAY_SRO &&
        listeSroZa.length > 0 &&
        listeSroZa
          .filter(
            zaSro =>
              (zaSro.item.properties.state === "SRO_DEP_201820" &&
                optionSelectedConfigCarte.SRO_DEP_201820) ||
              (zaSro.item.properties.state === "SRO_DEP_2021" &&
                optionSelectedConfigCarte.SRO_DEP_2021) ||
              (zaSro.item.properties.state === "SRO_DEP_2022" &&
                optionSelectedConfigCarte.SRO_DEP_2022) ||
              (zaSro.item.properties.state === "SRO_DEP_2023" &&
                optionSelectedConfigCarte.SRO_DEP_2023) ||
              (zaSro.item.properties.state === "SRO_OPEN" && optionSelectedConfigCarte.SRO_OPEN) ||
              (zaSro.item.properties.state === "SRO_SOON" && optionSelectedConfigCarte.SRO_SOON) ||
              (zaSro.item.properties.state === "SRO_YEAR_N0" &&
                optionSelectedConfigCarte.SRO_YEAR_N0) ||
              (zaSro.item.properties.state === "SRO_YEAR_N1" &&
                optionSelectedConfigCarte.SRO_YEAR_N1) ||
              (zaSro.item.properties.state === "SRO_YEAR_N2" &&
                optionSelectedConfigCarte.SRO_YEAR_N2),
          )
          .map(zaSro => (
            <GeoJSON key={zaSro.item.properties.referenceSRO} data={zaSro.item} style={zaSro.style}>
              <Popup maxWidth={260} autoPan={false}>
                <div>
                  <p className="popupTitle popupTitleColor alignCenter">Zone technique</p>
                  <p>
                    <span className="fontBold">Référence :</span>{" "}
                    {zaSro.item.properties.referenceSRO}
                    <br />
                    {!["SRO_OPEN", "SRO_SOON"].includes(zaSro.item.properties.state) &&
                      zaSro.item.properties.MOIS_COM &&
                      !removeInformationsDeploiementDsp.includes(dsp.codeReseau) && (
                        <>
                          <span className="fontBold">Déploiement :</span>{" "}
                          {zaSro.item.properties.MOIS_COM &&
                            `T${Math.ceil(zaSro.item.properties.MOIS_COM / 4)} `}
                          {zaSro.item.properties.anneeDep}
                        </>
                      )}
                  </p>
                </div>
              </Popup>
            </GeoJSON>
          ))}
    </Pane>
  );
};

ZaSro.propTypes = {
  dsp: propTypes.shape({
    logo: propTypes.string,
    codeMarche: propTypes.string,
    codeReseau: propTypes.string,
    libelle: propTypes.string,
    urlSite: propTypes.string,
    urlZonesDeploiement: propTypes.string,
    urlFibreFtth: propTypes.string,
    urlFibreSurDemande: propTypes.string,
    urlFibreFtte: propTypes.string,
    urlChangementAdresse: propTypes.string,
    urlListeOperateur: propTypes.string,
    urlPreparation: propTypes.string,
    secondaryMarches: propTypes.array,
  }).isRequired,
  marcheList: propTypes.array.isRequired,
  optionSelectedConfigCarte: propTypes.shape({
    LAYER_PLAN: propTypes.bool,
    LAYER_SAT: propTypes.bool,
    ALL_ZONES: propTypes.bool,
    SRO_DEP_201820: propTypes.bool,
    SRO_DEP_2021: propTypes.bool,
    SRO_DEP_2022: propTypes.bool,
    SRO_DEP_2023: propTypes.bool,
    SRO_OPEN: propTypes.bool,
    SRO_SOON: propTypes.bool,
    SRO_YEAR_N0: propTypes.bool,
    SRO_YEAR_N1: propTypes.bool,
    SRO_YEAR_N2: propTypes.bool,
    ZONE_RADIO: propTypes.bool,
    ZONE_AMII: propTypes.bool,
    ALL_STATUSES: propTypes.bool,
    IMB_RAC: propTypes.bool,
    IMB_ELIG: propTypes.bool,
    IMB_PROELIG: propTypes.bool,
    IMB_ETUDE: propTypes.bool,
    IMB_TRAVAUX_SECTEUR: propTypes.bool,
    IMB_TRAVAUX_RUE: propTypes.bool,
    IMB_DEMANDE: propTypes.bool,
    FTTE: propTypes.bool,
  }).isRequired,
  zoom: propTypes.number.isRequired,
  MIN_ZOOM_DISPLAY_SRO: propTypes.number.isRequired,
  MAX_ZOOM_DISPLAY_SRO: propTypes.number.isRequired,
  setIsLoading: propTypes.func.isRequired,
  enqueueSnackbar: propTypes.func.isRequired,
};
export default compose(withSnackbar)(ZaSro);
